export default __webpack_public_path__ + "static/media/logo.0a5c4aa7.png";